// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1w0Hw","footer":"ReportModalFilter_footer__2A7HW"};